import Component from '@glimmer/component';
import { on } from '@ember/modifier';
import { service } from '@ember/service';
import type RouterService from '@ember/routing/router-service';
import t from 'ember-intl/helpers/t';
import { VStack } from 'tio-ui/components/layout';
import Button from 'tio-ui/components/button';
import { PhPrinter } from 'ember-phosphor-icons';
import type { RecommendationExtension as RecommendationModel } from 'tio-data/data/resources/recommendation.ext';
import StrategyFinder0726PlanComparison from 'tio-employee/components/strategy-finder-0726/plan-comparison';
import StrategyFinder0726InputsSummary from 'tio-employee/components/strategy-finder-0726/inputs-summary';
import IdrDashboard0726ResultsTable from 'tio-employee/components/idr-dashboard-0726/results-table';
import { parseAndFilterResultSections } from 'tio-employee/utils/idr-dashboard-0726';

interface IdrDashboard0726ResultsSignature {
  Args: {
    recommendation: RecommendationModel;
  };
  Element: HTMLElement;
}

export default class IdrDashboard0726ResultsComponent extends Component<IdrDashboard0726ResultsSignature> {
  @service declare router: RouterService;

  // IDR-filtered sections (current + income-driven plans) so the comparison's
  // "best" is chosen among the same set the results table shows.
  get sections() {
    return parseAndFilterResultSections(
      this.args.recommendation.calculationInput,
      this.args.recommendation.calculationOutput
    );
  }

  printPdf = () => {
    window.print();
  };

  goToDashboard = () => {
    this.router.transitionTo('authenticated.idr.dashboard-0726.index');
  };

  <template>
    <VStack class="print-area" ...attributes>
      <StrategyFinder0726PlanComparison
        @recommendation={{@recommendation}}
        @sections={{this.sections}}
      />
      <IdrDashboard0726ResultsTable @recommendation={{@recommendation}} />
      <StrategyFinder0726InputsSummary @recommendation={{@recommendation}} />

      <div class="print-hide tio-row">
        <Button @intent="default" @appearance="outlined" {{on "click" this.printPdf}}>
          <PhPrinter class="mr-2" @size={{18}} />
          {{t "strategy_finder_0726.print_pdf"}}
        </Button>
        <Button @intent="default" @appearance="outlined" {{on "click" this.goToDashboard}}>
          {{t "idr_dashboard_0726.go_to_dashboard"}}
        </Button>
      </div>
    </VStack>
  </template>
}
